module.exports = __webpack_public_path__ + "static/media/clearAll.31fb43b2.svg";